var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureOverspeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5863 24.9789L29.1332 32.0571C28.951 32.3095 28.7295 32.5311 28.477 32.7133C27.8674 33.1385 27.1148 33.3062 26.3823 33.18C25.6499 33.0537 24.9969 32.6437 24.5649 32.0389C24.1329 31.4341 23.9568 30.6834 24.0749 29.9496C24.1931 29.2158 24.5958 28.5582 25.1957 28.1196L32.2738 23.6664C32.4347 23.5543 32.6262 23.4941 32.8223 23.4941C33.0184 23.4941 33.2098 23.5543 33.3707 23.6664C33.5728 23.8123 33.7089 24.0323 33.7493 24.2782C33.7897 24.5241 33.7311 24.7761 33.5863 24.9789Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0156 9.23828C15.4188 9.23828 6.01565 18.632 6.01565 30.2289C6.00853 35.3597 7.88693 40.3143 11.2938 44.1508C11.3969 44.2633 11.4906 44.3758 11.5938 44.4789C11.8156 44.7191 12.0849 44.9106 12.3846 45.0413C12.6843 45.1719 13.0079 45.239 13.3349 45.2381C13.6619 45.2372 13.9851 45.1684 14.2841 45.0361C14.5831 44.9038 14.8513 44.7109 15.0719 44.4695C16.5921 42.8175 18.4384 41.4988 20.4942 40.5968C22.55 39.6948 24.7706 39.2291 27.0156 39.2291C29.2606 39.2291 31.4812 39.6948 33.5371 40.5968C35.5929 41.4988 37.4392 42.8175 38.9594 44.4695C39.1799 44.7109 39.4482 44.9038 39.7472 45.0361C40.0462 45.1684 40.3694 45.2372 40.6964 45.2381C41.0234 45.239 41.3469 45.1719 41.6466 45.0413C41.9464 44.9106 42.2157 44.7191 42.4375 44.4789L42.7375 44.1508C46.1444 40.3143 48.0228 35.3597 48.0156 30.2289C48.0156 18.632 38.6125 9.23828 27.0156 9.23828Z",
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0156 15.2383V18.2383M42.0156 30.2383H39.0156M15.0156 30.2383H12.0156M18.5303 21.753L16.4088 19.6314M35.5009 21.753L37.6225 19.6314",
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureOverspeed);
export default __webpack_public_path__ + "static/media/Feature_overspeed.24d8eeb0ce8c6cb158ae031007e6ea35.svg";
export { ForwardRef as ReactComponent };